import { NavLink as MantineNavLink } from '@mantine/core';
import { ReactNode } from 'react';

interface Props {
    label: string;
    leftSection?: ReactNode;
    onClick: () => void;
    active: boolean;
}

export const NavLink = ({ label, leftSection, onClick, active }: Props) => {
    return (
        <MantineNavLink
            classNames={{
                root: 'opacity-50 transition-opacity hover:bg-transparent hover:opacity-100 data-[active=true]:font-bold data-[active=true]:opacity-100',
                label: 'hover:bg-transparent',
            }}
            onClick={onClick}
            active={active}
            leftSection={leftSection}
            label={label}
            variant="subtle"
        />
    );
};
